import { render, staticRenderFns } from "./NavigationPage.vue?vue&type=template&id=0198f12c&scoped=true"
import script from "./NavigationPage.vue?vue&type=script&lang=js"
export * from "./NavigationPage.vue?vue&type=script&lang=js"
import style0 from "./NavigationPage.vue?vue&type=style&index=0&id=0198f12c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0198f12c",
  null
  
)

export default component.exports